<script setup lang="ts">
interface Testimonial {
  name: string
  avatar: string
  quote: string
  background?: string
}

defineProps<{
  testimonials: Testimonial[]
  videoPoster: string
  videoSrc: string
}>()
</script>

<template>
  <div class="backdrop-blur-md bg-black/50 border border-white/10 flex flex-col lg:flex-row gap-6 items-start overflow-hidden p-6 relative rounded-[44px] w-full">
    <div class="flex flex-col gap-6 w-full lg:w-[354px] shrink-0 self-stretch">
      <div
        v-for="(item, index) in testimonials.slice(0, 2)"
        :key="index"
        class="flex-1 bg-[#030f12] border border-white/20 flex flex-col gap-14 items-start overflow-hidden p-6 relative rounded-3xl w-full group"
      >
        <!-- Background elements for the first testimonial as seen in Figma -->
        <template v-if="index === 0 && item.background">
          <div class="absolute inset-0 -z-10 flex items-center justify-center pointer-events-none scale-150">
            <div class="relative w-full h-full">
              <div
                class="absolute inset-0 mix-blend-luminosity opacity-50 bg-center bg-cover"
                :style="{ backgroundImage: `url(${item.background})` }"
              />
              <div class="absolute inset-0 bg-[#0095ff] mix-blend-color opacity-50" />
              <div class="absolute inset-0 bg-black/50" />
            </div>
          </div>
        </template>

        <div class="flex gap-2 items-center relative w-full">
          <UAvatar
            :src="item.avatar"
            :alt="item.name"
            size="sm"
            class="border-[#c40026] border-[0.667px] rounded-[16px]"
          />
          <div class="capitalize font-display font-semibold text-[18px] text-white/85 tracking-[-0.18px]">
            {{ item.name }}
          </div>
        </div>

        <div class="flex flex-col items-start relative w-full">
          <p class="font-magic text-sm text-white uppercase text-shadow-[0px_2px_6px_rgba(0,0,0,0.06)] leading-normal">
            {{ item.quote }}
          </p>
        </div>
      </div>
    </div>

    <!-- Video side -->
    <div class="grow bg-white/5 border border-white/10 h-137 overflow-hidden relative rounded-4xl w-full lg:w-auto">
      <video
        class="w-full h-full object-cover"
        :poster="videoPoster"
        controls
      >
        <source
          :src="videoSrc"
          type="video/mp4"
        >
      </video>
    </div>
  </div>
</template>

<style scoped>
.font-display {
  font-family: 'Clash Grotesk Variable', sans-serif;
}
.font-magic {
  font-family: 'Supercell-Magic', sans-serif;
}
</style>
